import { render, staticRenderFns } from "./TaskDely.vue?vue&type=template&id=075bcc0f&scoped=true"
import script from "./TaskDely.vue?vue&type=script&lang=js"
export * from "./TaskDely.vue?vue&type=script&lang=js"
import style0 from "./TaskDely.vue?vue&type=style&index=0&id=075bcc0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075bcc0f",
  null
  
)

export default component.exports